// extracted by mini-css-extract-plugin
export default {"bot-loader":"BotLoader_bot-loader__xkMIr","profile-image":"BotLoader_profile-image__0eEcR","svg":"BotLoader_svg__wfpwe","loader":"BotLoader_loader__r1mvY"};